module.exports = __webpack_public_path__ + "static/media/logo-syngeos@2x.677783b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-syngeos@2x.png
// module id = 397
// module chunks = 0